export default __webpack_public_path__ + "static/media/lofihours.f08b1138.png";